export default "__VITE_ASSET__ZdPx7VL0__"